var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"d-flex flex-column h-100"},[_c('AppContent')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }